import { render, staticRenderFns } from "./ReservationInvoiceAddress.vue?vue&type=template&id=386b2b4a"
import script from "./ReservationInvoiceAddress.vue?vue&type=script&lang=js"
export * from "./ReservationInvoiceAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports